module.exports = __webpack_public_path__ + "static/media/background-710.d2a8d6c6.jpg";